/** Shared react-hot-toast classes. */
export const baseToastClassName =
  "rounded-xl border px-4 py-3 text-sm shadow-lg backdrop-blur !max-w-md";
